import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { pluralize } from '@warp-drive/utilities/string';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

import modelIcon from 'umg-ember-backend/helpers/model-icon';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class ApplicationNavigationItemComponent extends Component {
  // Services
  @service breadcrumb;
  @service intl;
  @service router;

  // Getter and setter
  get isActive() {
    if (this.breadcrumb.firstRoute) {
      return this.breadcrumb.firstRoute?.routeName.includes(this.route);
    }

    return this.router.currentRouteName?.includes(this.route);
  }

  get label() {
    let intl = this.intl;
    let key = this.args.item.key;

    let path = `models.plurals.${key}`;
    if (intl.exists(path)) {
      return intl.t(path);
    }

    return intl.t(`application.navigation.item.${key}`);
  }

  get route() {
    return this.args.item.route ?? `admin.${pluralize(this.args.item.key)}`;
  }

  // Template
  <template>
    <li
      class={{bem (hash is-child=@isChild is-active=this.isActive)}}
      ...attributes
    >
      <LinkTo
        @route={{this.route}}
        class={{bem 'link'}}
        {{on 'click' @onCloseNavigation}}
      >
        {{#unless @isChild}}
          {{svgJar (modelIcon @item.key) class=(bem 'icon')}}
        {{/unless}}
        <span class={{bem 'label'}}>{{this.label}}</span>
      </LinkTo>
    </li>
  </template>
}
